
import { useTranslation } from 'react-i18next';

export function About() {
  const { t } = useTranslation('common');

  // Helper function to safely get translations with fallback
  const safeT = (key: string, fallback: string = key) => {
    const translation = t(key);
    return translation === key ? fallback : translation;
  };

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              {safeT('about.title', 'About Us')}
            </h2>
            <p className="text-xl text-gray-700 mb-6 leading-relaxed">
              {safeT('about.description1', 'We provide exceptional technical consulting services')}
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              {safeT('about.description2', 'With years of experience in the industry')}
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {safeT('about.description3', 'Ensuring compliance and quality in every project')}
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-orange-50 rounded-xl p-6 border-l-4 border-orange-500">
                <div className="text-3xl font-bold text-orange-500 mb-2">19+</div>
                <div className="text-sm text-gray-700 font-semibold">
                  {safeT('about.yearsExperience', 'Years of Experience')}
                </div>
              </div>
              <div className="bg-blue-50 rounded-xl p-6 border-l-4 border-blue-900">
                <div className="text-3xl font-bold text-blue-900 mb-2">100%</div>
                <div className="text-sm text-gray-700 font-semibold">
                  {safeT('about.complianceGuaranteed', 'Compliance Guaranteed')}
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/29df5764fe1e978385ddd62b4f04fc42.png"
              alt="Consultoria Técnica APL"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
              onError={(e) => {
                console.warn('Image failed to load, using fallback');
                e.currentTarget.src = '/fallback-image.jpg';
              }}
            />
            <div className="absolute -bottom-8 -left-8 bg-orange-500 text-white p-8 rounded-xl shadow-xl max-w-xs">
              <i className="ri-award-fill text-4xl mb-3"></i>
              <p className="font-bold text-lg">
                {safeT('about.badge', 'Certified Excellence')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
